exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".table[data-v-530f4a3f]{table-layout:auto;overflow-x:scroll}.tbody td[data-v-530f4a3f]{width:auto;overflow-x:scroll}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"id":"data-v-530f4a3f","scoped":true,"sourceMap":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./App/Components/Borrow/JobBorrowProductReturnItemRow.vue
// module id = 955
// module chunks = 0